import React, { useEffect } from 'react'
import { NotificationsProps } from './Notifications.types'
import { User } from 'utilities'
import {
  IconErrorSmall,
  IconInfoSmall,
  IconNotifications,
  IconSuccessSmall,
  IconWarningSmall
} from 'assets'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { NOTIFICATIONS_STORE } from 'store'
import { HeaderNotifications } from '@touche-lts/panel-ui/dist'

const NotificationsComponent = (props: NotificationsProps) => {
  const {
    className,
    style,
    [NOTIFICATIONS_STORE]: {
      getNotifications,
      newNotificationsCount,
      userNotificationsList,
      markNotificationSeen
    }
  } = props

  useEffect(() => {
    getNotifications()
  }, [getNotifications])

  return (
    <HeaderNotifications
      className={className}
      style={style as any}
      disabled={!User.isAuthenticated()}
      iconNotifications={IconNotifications as any}
      markNotificationSeen={markNotificationSeen}
      newNotificationsCount={newNotificationsCount}
      userNotificationsList={userNotificationsList}
      typeIcons={{
        ERROR: IconErrorSmall as any,
        INFO: IconInfoSmall as any,
        OK: IconSuccessSmall as any,
        WARNING: IconWarningSmall as any
      }}
    />
  )
}

const Notifications = inject('NOTIFICATIONS_STORE')(
  observer(NotificationsComponent)
)
export { Notifications }
